export const DEFAULT_MONEY_TYPE = 'centPrecision';
